/** Fixed width (px) for the docked campaign chat panel. */
export const CHAT_PANEL_WIDTH = 420
